import { AppointmentSpeciality } from '@avanta/shared/constants/appointments';

export const SPECIALITIES_WITH_SHARED_COUPONS: ReadonlySet<number> = new Set([
  AppointmentSpeciality.ADULT_PSYCHOLOGY,
  AppointmentSpeciality.PAE,
]);
